export const buildPublishedCareerCriteria = (companyId) => ({
    company: { primaryId: companyId },
    status: "PUBLISHED"
});

export const buildCareerResumeUploadFormData = (resumeFile, companyId) => {
    const formData = new FormData();
    formData.append("file", resumeFile);
    formData.append("companyFolderId", `${companyId}/career-applications`);
    return formData;
};

export const buildCareerApplicationPayload = (application = {}) => ({
    createdBy: application.createdBy
        || `${application.firstName || application.applicant?.firstName || ""} ${application.lastName || application.applicant?.lastName || ""}`.trim()
        || null,
    company: {
        primaryId: application.company?.primaryId || application.companyId,
    },
    career: {
        primaryId: application.career?.primaryId || application.careerId,
    },
    applicant: {
        ...(application.applicant || {}),
        firstName: application.applicant?.firstName || application.firstName,
        lastName: application.applicant?.lastName || application.lastName,
        email: application.applicant?.email || application.email,
        phoneNumber: application.applicant?.phoneNumber || application.phoneNumber,
        countryCode: application.applicant?.countryCode || application.countryCode || "1",
        userRole: "APPLICANT",
        userRoles: ["APPLICANT"],
        company: {
            primaryId: application.company?.primaryId || application.companyId,
        },
    },
    currentLocation: application.currentLocation,
    linkedInUrl: application.linkedInUrl,
    portfolioUrl: application.portfolioUrl,
    noticePeriod: application.noticePeriod,
    expectedCompensation: application.expectedCompensation,
    whyWorkWithUs: application.whyWorkWithUs,
    resumeObjectKey: application.resumeObjectKey || application.resumeUrl,
    resumeUrl: application.resumeUrl || application.resumeObjectKey,
    resumeFileName: application.resumeFileName,
    resumeContentType: application.resumeContentType,
    resumeSize: application.resumeSize,
});
